import React, { useContext, useEffect } from "react";
import { colorPalette } from "../utils/consts";
import CalendarView from "./CalendarView";
import CompanyHeader from "./CompanyHeader";
import Chat from "./Chat";
import MeetingControls from "./MeetingControls";
import { UserContext, USER_ROLES } from "./UserProvider";

const Home = ({ companyProfile, hosts, sidebarCollapsed, chatLoaded }) => {
  const { userProfile, role } = useContext(UserContext);

  useEffect(() => {
    if (role === USER_ROLES.HOST || role === USER_ROLES.ADMIN) {
      if (chatLoaded &&
        window.MessagingHub &&
        companyProfile &&
        companyProfile.CompanyProfileID
      ) {
        window.MessagingHub.meetingSuite().set({
          CompanyID: companyProfile.CompanyProfileID,
          MeetingArea: "home",
          MeetingID: null,
          UserRole: role
        });
      } 
    }else{
      return;
    }
  }, [companyProfile, role, chatLoaded]);

  return (
    <div className="row h-100">
      <div className="col-sm-12 col-md-8 col-xl-9">
        <div className="header text-center text-uppercase my-3">
          <CompanyHeader profile={companyProfile} />
        </div>

        {companyProfile && hosts && hosts.length > 0 && userProfile && (
          <div>
            <CalendarView
              colorPalette={colorPalette}
              AllUsers={hosts}
              CompanyProfileID={companyProfile.CompanyProfileID}
              selectLoggedInUser={true}
              userProfile={userProfile}
            />

            <MeetingControls companyProfile={companyProfile} />
          </div>
        )}
      </div>

      <div className="col-sm-12 col-md-4 col-xl-3 px-0">
        <Chat sidebarCollapsed={sidebarCollapsed} />
      </div>
    </div>
  );
};

export default Home;
